export const SET_UITEXTS = 'setUITexts';

export const SET_COMPANION = 'setCompanion';

export const SET_ENTRY = 'setEntry';
export const SET_KAM = 'setKam';
export const SET_ME = 'setMe';
export const RESET_ME = 'resetMe';
export const POST_SET_ME = 'postSetMe';
export const SET_APPOINTMENT = 'setAppointment';
export const SET_BOOKED_APPOINTMENT = 'setBookedAppointment';
export const SET_APPOINTMENT_BOOKING = 'setAppointmentBooking';
export const SET_APPOINTMENT_CANCELLED = 'setAppointmentCancelled';
export const SET_APPOINTMENTS_BLOCKED = 'setAppointmentBlocked';
export const SET_APPOINTMENT_KAM_CANCELLED = 'setAppointmentKamCanbcelled';

export const SET_STANDGUIDANCE = 'setStandGuidance';
export const SET_BOOKED_STANDGUIDANCE = 'setBookedStandGuidance';
export const SET_STANDGUIDANCE_BOOKING = 'setStandGuidanceBooking';
export const SET_STANDGUIDANCE_CANCELLED = 'setStandGuidanceCancelled';

export const SET_PAGE = 'setPage';
export const RESET_PAGE = 'resetPage';

export const POST_START = 'postStart';
export const POST_END = 'postEnd';

export const SET_COMPANION_FILTER_TOPIC = 'setCompanionFilterTopic';
export const SET_COMPANION_FILTER_CATEGORY_ADD = 'setCompanionFilterCategoryAdd';
export const SET_COMPANION_FILTER_CATEGORY_REMOVE = 'setCompanionFilterCategoryRemove';
export const SET_COMPANION_FILTER_SEARCH = 'setCompanionFilterSearch';

export const SET_NUGGET = 'setNugget';
export const RESET_NUGGET = 'resetNugget';
export const SET_SLUG = 'setSlug';

export const SET_COLLECTION = 'setCollection';

export const SET_LOGIN = 'setLogin';
export const RESET_LOGIN = 'resetLogin';

export const SET_KNOWLEDGE_TEST = 'setKnowledgeTest';

export const FETCH_START = 'fetchStart';
export const FETCH_END = 'fetchEnd';

export const BOOK_START = 'bookStart';
export const BOOK_END = 'bookEnd';

export const CANCEL_START = 'cancelStart';
export const CANCEL_END = 'cancelEnd';

export const SET_HEADER_PIN = 'setHeaderPin';
export const SET_HEADER_HEIGHT = 'setHeaderHeight';

export const SET_APP_SWITCH_LANGUAGE = 'setAppSwitchLanguage';
export const SET_LANGUAGE = 'setLanguage';